module.exports = __webpack_public_path__ + "img/banner7.c61466ca.png";